/**
 *
 * Formatted
 *
 */

import * as PropTypes from "prop-types";
import { createSelector } from "reselect";
import { connect } from "react-redux";
import * as DateUtils from "../../utils/Date";
import { makeSelectLocale } from "../../containers/LanguageProvider/selectors";

function Formatted({ locale, format, date, inputFormat }) {
  let formattedDate = "";
  if (inputFormat) {
    formattedDate = DateUtils.format(locale, format, date, inputFormat);
  } else {
    formattedDate = DateUtils.format(locale, format, date);
  }
  return <span>{formattedDate}</span>;
}

Formatted.propTypes = {
  date: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  format: PropTypes.string.isRequired,
  locale: PropTypes.string.isRequired,
  inputFormat: PropTypes.string,
};

Formatted.defaultProps = {
  inputFormat: DateUtils.DATE_FORMATS.DATE_TIME,
};

const mapStateToProps = createSelector(makeSelectLocale(), locale => ({
  locale,
}));

export const DATE_FORMATS = DateUtils.DATE_FORMATS;

export default connect(mapStateToProps)(Formatted);
